export default "__VITE_ASSET__guTL_mRQ__"